import { useDbClient } from "@tanstack/react-db";
import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { resetSavedListingIds } from "@/features/saved-listings";
import { refetchAuthSession } from "@/lib/core/auth-protocol";
import { invalidateViewerScopedQueries } from "../invalidate-viewer-scoped-queries";

export function useContactVerifiedRefresh() {
    const queryClient = useQueryClient();
    const dbClient = useDbClient();
    const router = useRouter();
    return async () => {
        await refetchAuthSession();
        resetSavedListingIds(dbClient);
        invalidateViewerScopedQueries(queryClient);
        void router.invalidate();
    };
}
